// extracted by mini-css-extract-plugin
module.exports = {"botao":"Botao_botao__1Ir4S"};